import * as Mod1 from "./discourse/components/base-captcha";
import * as Mod2 from "./discourse/components/h-captcha";
import * as Mod3 from "./discourse/components/re-captcha";
import * as Mod4 from "./discourse/connectors/code-login-after-code/captcha-fields-connector.gjs";
import * as Mod5 from "./discourse/connectors/create-account-after-user-fields/captcha-fields-connector.gjs";
import * as Mod6 from "./discourse/initializers/hcaptcha-admin-plugin-configuration-nav";
import * as Mod7 from "./discourse/services/captcha-service";
import * as Mod8 from "./pre-initializers/h-captcha";
const compatModules = {
  "discourse/components/base-captcha": Mod1,
  "discourse/components/h-captcha": Mod2,
  "discourse/components/re-captcha": Mod3,
  "discourse/connectors/code-login-after-code/captcha-fields-connector": Mod4,
  "discourse/connectors/create-account-after-user-fields/captcha-fields-connector": Mod5,
  "discourse/initializers/hcaptcha-admin-plugin-configuration-nav": Mod6,
  "discourse/services/captcha-service": Mod7,
  "pre-initializers/h-captcha": Mod8,
};
export default compatModules;
